import workspaceQuery from '../../queries/purchases/PurchaseCostWorkspaceQuery.graphql';
import listQuery from '../../queries/purchases/PurchaseCostListQuery.graphql';
import instanceQuery from '../../queries/purchases/PurchaseCostQuery.graphql';
import defaultQuery from '../../queries/purchases/PurchaseCostDefault.graphql';
import mutationQuery from '../../mutations/purchases/PurchaseCostMutation.graphql';
import fragment from '../../fragments/purchases/PurchaseCostFragment.graphql';
import { Direction } from '../../schema/p4types';

const PurchaseCost = {
  type: 'PurchaseCost',
  title: 'Purchase Costs',
  formTitle: 'Purchase Cost',
  formUrl: '/Purchasing/Cost/Details/',
  workspaceUrl: '/Purchasing/Cost/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    customVariables: () => {
      return {
        orderBy: 'description',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'PURCHASE_COST',
};

export default PurchaseCost;
